
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/pro/[vertical]/[category]/[slug]",
      function () {
        return require("private-next-pages/content/pro/[vertical]/[category]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/pro/[vertical]/[category]/[slug]"])
      });
    }
  